import { EdwinCloudApiClient } from '@edwin/api-client'

export const edwinCloudApiClient = new EdwinCloudApiClient()
